  
// marker tab on click img and bold text
document.addEventListener("DOMContentLoaded", function () {
    const images = document.querySelectorAll(".process-image");
    const texts = document.querySelectorAll(".pro-text");

    images.forEach(image => {
      image.addEventListener("click", function () {
        const index = this.querySelector("img").getAttribute("index");

        // Remove class from all text spans
        texts.forEach(text => text.classList.remove("active"));

        // Add class to the one with matching index
        document.querySelector(`.pro-text[index="${index}"]`).classList.add("active");
      });
    });
  });

// menu hover filter
function applyHoverMenuState() {
  const isDesktop = window.innerWidth >= 1025; // You can adjust this breakpoint as per theme
  const savedTitle = localStorage.getItem('activeMenuTitle') || document.querySelector('.filter__menu li')?.getAttribute('data-title');
  const filterMatch = document.querySelector(`.filter__menu li[data-title="${savedTitle}"]`);

  if (!isDesktop) return; // 💡 Prevent execution on mobile

  if (filterMatch) {
    // Remove all previous active states
    document.querySelectorAll('.filter__menu li').forEach(fItem => fItem.classList.remove('active'));
    document.querySelectorAll('.child-menu').forEach(cMenu => cMenu.classList.remove('show'));

    // Apply new active state
    filterMatch.classList.add('active');

    // Only update summary in desktop
    const summarySpans = document.querySelectorAll('.facets__summary.menu-link span');
    summarySpans.forEach(span => {
      span.textContent = savedTitle;
    });

    const childMenu = filterMatch.querySelector('.child-menu');
    if (childMenu) childMenu.classList.add('show');
  }
}

window.addEventListener('DOMContentLoaded', () => {
  applyHoverMenuState();

  // Apply hover events for desktop only
  if (window.innerWidth >= 1025) {
    document.querySelectorAll('#hovermenu .link-main-header').forEach(headerItem => {
      headerItem.addEventListener('mouseenter', () => {
        const title = headerItem.getAttribute('data-title');
        localStorage.setItem('activeMenuTitle', title);
        applyHoverMenuState();
      });
    });
  }
});

// Optional: for AJAX re-renders
document.addEventListener('shopify:section:load', () => {
  applyHoverMenuState();
});

// mobile filter menu 

document.addEventListener('DOMContentLoaded', () => {
  const KEY = 'lastClickedMenuTitle';

  // Save clicked title
  document.querySelectorAll('.link-main-header, .link-main-header a').forEach(el =>
    el.addEventListener('click', () => {
      const title = (el.getAttribute('data-title') || el.textContent || '').trim().toLowerCase();
      if (title) localStorage.setItem(KEY, title);
    })
  );

  const saved = localStorage.getItem(KEY);
  if (!saved) return;

  // Show only matching filter menu & hide others
  document.querySelectorAll('.filter__menu.mobile-menu').forEach(menu => {
    const menuTitle = (menu.dataset.title || '').trim().toLowerCase();
    menu.style.display = (menuTitle === saved) ? '' : 'none';

    // Remove active classes
    menu.querySelectorAll('.filter-menu__link--active').forEach(a => a.classList.remove('filter-menu__link--active'));

    // Add active class on matched li or a
    [...menu.querySelectorAll('li[data-title], a')].forEach(el => {
      const elTitle = (el.dataset.title || el.textContent || '').trim().toLowerCase();
      if (elTitle === saved) el.classList.add('filter-menu__link--active');
    });
  });
});


// customize product js
if (document.getElementById('people_data')) {
  document.getElementById('people_data').addEventListener('submit', function (e) {
    e.preventDefault();
  
    const form = e.target;
    const formData = new FormData(form);
    const metfilds_key = 'person';
    const formFields = {};
  
    // Convert form data to object
    formData.forEach((value, key) => {
      formFields[key] = value;
    });

    if (formFields['select-outfit'] && !formFields['outfit-auswahlen']) {
      formFields['outfit-auswahlen'] = formFields['select-outfit'];
    }
    delete formFields['select-outfit'];
  
    // Get existing data or initialize empty array
    let existingData = JSON.parse(localStorage.getItem('peopel_data'));
    if (!Array.isArray(existingData)) {
      existingData = [];
    }
  
    const nextId = Math.floor(Math.random() * 1000000).toString();
  
    const newEntry = {
      id: nextId,
      profile: {},
      ...formFields
    };
  
    existingData.push(newEntry);
  
    // Save back to localStorage
    localStorage.setItem('peopel_data', JSON.stringify(existingData));
  
    // console.log('Updated Form Data:', existingData);
  
    people_data_upload(existingData, metfilds_key);
  
    form.reset();
  });

}

const editForm = document.querySelectorAll('[edit_person_data-submit-js]');
if (editForm) {
  const metfilds_key = 'person';
  editForm.forEach(item => {
    item.addEventListener('submit', function (e) {
      e.preventDefault();
    
      const form = e.target;
      const formData = new FormData(form);
      const formFields = {};
      const existingData = JSON.parse(localStorage.getItem('peopel_data')) || [];
    
      // Get the submitted ID from a custom attribute
      const submittedId = form.getAttribute('form_person_id');
      console.log("formData:", formData);
    
      // Convert formData to object
      formData.forEach((value, key) => {
        console.log(key,value)
        formFields[key] = value;
      });
      if (formFields['select-outfit'] && !formFields['outfit-auswahlen']) {
        formFields['outfit-auswahlen'] = formFields['select-outfit'];
      }
      delete formFields['select-outfit'];
    // return ;
      // Find index of matching entry by ID
      const indexToUpdate = existingData.findIndex(entry => entry.id === submittedId);
      // console.log("Index to update:", indexToUpdate);
    
      if (indexToUpdate !== -1) {
        // Merge and update the entry
        existingData[indexToUpdate] = {
          ...existingData[indexToUpdate],
          ...formFields,
          id: submittedId
        };
    
        // localStorage.setItem('peopel_data', JSON.stringify(existingData));
        // console.log('Updated entry:', existingData[indexToUpdate]);
        console.log("existingData",existingData);
         people_data_upload_edit(existingData,metfilds_key);
         const selects = this.querySelectorAll('.multi-field select');
        //  const peopelget = this.querySelector('[data_append_form]');
        //   console.log(peopelget,'peopelget')
        // const items = [];
        // selects.forEach((select) => {
        //   const selectedOption = select.options[select.selectedIndex]; // get selected <option>
        //   const variantIde = selectedOption.getAttribute('data-newvariant-id');

        //   console.log('Selected variant ID:', variantIde);
        //       if (variantIde) {
        //         items.push({
        //           id: parseInt(variantIde), // convert to number
        //           quantity: 1,
        //           properties: {
        //             "_pople_data": this.getAttribute('people_data_new'),
        //             "_outfit_data": peopelget.getAttribute('outfit__data_new'),
        //           },
        //         });
        //       }
        // });
        //     if (items.length > 0) {
        //       addToCart(items);
        //     }

      } else {
        // console.log(`Entry with ID "${submittedId}" not found. No update performed.`);
      }    
    });
  });
}


const colorPickers = document.querySelectorAll('[color_code]');

colorPickers.forEach(picker => {
  picker.addEventListener('input', function () {
    const selectedColor = this.value;
    const pickerId = this.id;

    // Find matching text input
    const textInput = document.querySelector(`[color_input="${pickerId}"]`);
    const textspan = document.querySelector(`[color_span="${pickerId}"]`);
    if (textInput && textspan) {
      textInput.textContent = selectedColor;
      textspan.style.backgroundColor = selectedColor;
    }
  });
});


if (document.getElementById('company_data')) {
  document.getElementById('company_data').addEventListener('submit', function (e) {
    e.preventDefault();
  
    const form = e.target;
    const formData = new FormData(form);
    const metfilds_key = 'company';
    const formFields = {};
    const existingData = [];
  
    // Convert form data to object
    formData.forEach((value, key) => {
      formFields[key] = value;
    });
  
    const nextId = Math.floor(Math.random() * 1000000).toString();
  
    const newEntry = {
      id: nextId,
      profile: {},
      ...formFields
    };
  
    existingData.push(newEntry);
  
    // Save back to localStorage
    localStorage.setItem('company_data', JSON.stringify(existingData));
  
    console.log('Updated Form Data:', existingData);
  
    people_data_upload(existingData, metfilds_key, true);
  
    form.reset();
  });
}


const outfitSelector = document.querySelector("[outfit_data]");
if (outfitSelector) {
  outfitSelector.addEventListener("change", function () {
    const appendTarget = document.querySelector('[data_append]');
    if (!appendTarget) return;

    const selectedOutfit = this.value;
  
    document.querySelectorAll("[size_field]").forEach(function (el) {
      // console.log("id",el.getAttribute("outfit_id"))
      
      if (el.getAttribute("outfit_id") === selectedOutfit) {

        
        el.classList.remove("hidden");
         appendTarget.innerHTML = el.outerHTML;
         const selects = document.querySelectorAll('[data_append] .field select');

        // helper function
        const normalizeKey = (str) =>
          str.toLowerCase().replace(/\s+/g, '').trim();

        // Get storedData once
        const rawStoredData = JSON.parse(localStorage.getItem('selectedSizes')) || {};
        console.log(rawStoredData, selects, "storedData");

        // normalize storedData keys
        const storedData = {};
        Object.keys(rawStoredData).forEach(key => {
          storedData[normalizeKey(key)] = rawStoredData[key];
        });

        selects.forEach(select => {
          console.log("selectsselects");

          const selectName = normalizeKey(select.name);

          // ✅ Exact key match after normalization
          if (storedData.hasOwnProperty(selectName)) {
            const valueToSelect = storedData[selectName];
            console.log(selectName, valueToSelect, select.options, "selected value");

            const optionExists = Array.from(select.options)
              .some(opt => opt.value === valueToSelect);

            if (optionExists) {
              console.log(optionExists, 'optionExists');
              select.value = valueToSelect;
              select.dispatchEvent(new Event('change'));
            } else {
              console.warn(`Value "${valueToSelect}" not found in select "${selectName}"`);
            }
          }
        });

      } else {
        // el.classList.add("hidden");
      }
    });
  });
}

const editoutfitSelector = document.querySelectorAll("[edit_outfit_data]");
if (editoutfitSelector) {
  editoutfitSelector.forEach(item => {
    item.addEventListener("change", function () {
      const parentdiv = item.closest('[edit_person_data]');
      if (!parentdiv) return;

      const target = parentdiv.querySelector('[data_append_form]');
      if (target) {
        target.classList.remove('hidden');
      }
    });
  });
}

const peopleaddToCart = document.querySelectorAll('[addToCartButton]');
if (peopleaddToCart) {
  peopleaddToCart.forEach(item => {
    item.addEventListener("click", function () {

      const parenDiv = item.closest('[people-outfit-details]');
      if (!parenDiv) return;

      const variantElements = parenDiv.querySelectorAll('[outfit-measurement-wrap] .measurement-value');

      const items = [];

      variantElements.forEach(el => {

        const existingData = JSON.parse(localStorage.getItem('customProductSets')) || [];
        const dataoutfit = el.getAttribute('data-new-outfitid');
        const productHandlee = el.getAttribute('data-new-handle');
        const outfitDataRaw = el.getAttribute('outfit__data');
        let outfitData = null;

        try {
          outfitData = outfitDataRaw ? JSON.parse(outfitDataRaw) : null;
        } catch (error) {
          outfitData = null;
        }

        const matchedSet = existingData.find(item =>
          item.id && dataoutfit && item.id.toString() === dataoutfit.toString()
        );

        let productJson = null;
        if (matchedSet) {
          Object.keys(matchedSet).forEach(key => {
            if (!isNaN(key)) {
              const prod = matchedSet[key];
              if (prod && prod.product_heandle && productHandlee &&
                prod.product_heandle.toString() === productHandlee.toString()) {
                productJson = prod;
              }
            }
          });
        }

        const variantId = el.getAttribute('variant_id')
          || productJson?.varent_id
          || outfitData?.varent_id;
        const itemQuantity = Number(productJson?.qtu || outfitData?.qtu || 1);

        let cartItem = null;

        // PUSH NORMAL ITEM FIRST
        if (variantId && outfitData) {
          cartItem = {
            id: Number(variantId),
            quantity: itemQuantity,
            properties: {
              "_pople_data": el.getAttribute('people_data'),
              "_outfit_data": el.getAttribute('outfit__data'),
              "_product_custom_image": el.getAttribute('outfit-customize-image'),
            }
          };

          items.push(cartItem);
        }
      const data_metaprice = Number(el.getAttribute('data-meta-price-second')) || 0;
      let totalPriceSKUh = 0;
      if (!cartItem) return;
      const peopleData = el.getAttribute('people_data');

        if (peopleData) {
            const obj = JSON.parse(peopleData);

            const id = obj.id;
            const vorname = obj.vorname;
            const nachname = obj.nachname;

            // Combine first + last name
            const fullName = `${vorname} ${nachname}`;

            // Add to line item properties
            cartItem.properties["Mitarbeiter"] = fullName;
            cartItem.properties["Person ID"] = id;
        }

      // ✔ Custom properties ONLY if matched
      const item_main_serlect_custom = selectedproducts.find(
        item => Number(item.id) === Number(productJson?.customize_id)
      );

      if (item_main_serlect_custom != null) {

        let obj = productJson.product_custom_oject;
        let veredelungObj = productJson.product_custom_Veredelung;
        let subImages = item_main_serlect_custom.sub_images;
        const mainId = item_main_serlect_custom.id;

        let indexCounter = 1;

        Object.keys(obj).forEach(keyId => {


          const jsonString = productJson.product_custom_oject[keyId];

             const isValid = hasavalable(jsonString);
              // If validation true → add to object
              console.log("isValid",isValid);
              if (!isValid === true)  return; // continue

          let combinedKey = mainId + "_&&_" + keyId;

          // NO MATCH? SKIP
          if (!veredelungObj.hasOwnProperty(combinedKey)) return;

          let matchedValue = veredelungObj[combinedKey];
          let index = parseInt(keyId);

          if (!subImages[index]) return;

          let label = subImages[index].label;
          let sku = "";
          let price = "";
          let type = matchedValue;

          if (matchedValue === "Stick") {
            sku = subImages[index].sku;
            price = subImages[index].price;
          }
          else if (matchedValue === "Druck") {
            sku = subImages[index].sku_Druck;
            price = subImages[index].price_Druck;
          }

          if (!sku) return;

          // Add SKU price (convert to euro)
          totalPriceSKUh += Number(price);

          // Add matched properties
          cartItem.properties[`Label ${indexCounter}`] = label;
          cartItem.properties[`Type ${indexCounter}`] = type;
          cartItem.properties[`SKU_${type} ${indexCounter}`] = sku;
          cartItem.properties[`Price_${type} ${indexCounter}`] = price;

          indexCounter++;
        });
      }

      // ------------------------------
      // ✔ FINAL PRICE = main + SKU sum
      // ------------------------------
      const finalPricee = data_metaprice + totalPriceSKUh;
      console.log(data_metaprice,totalPriceSKUh,finalPricee,'totalPriceSKU');

      // cartItem.properties["_discount_custom_price"] = finalPricee * 1.19;



       

      });

      console.log("Adding to cart:", items);
      if (items.length > 0) addToCart(items);

    });
  });
}




// =================== NEW JS (H)==========
const selects = document.querySelectorAll('[data_append] .field__select');

if (selects.length > 0) {
  selects.forEach(select => {
    select.addEventListener('change', function () {
      const selectName = this.name;
      const selectedValue = this.value;

      let storedData = JSON.parse(localStorage.getItem('selectedSizes')) || {};
      storedData[selectName] = selectedValue;
      localStorage.setItem('selectedSizes', JSON.stringify(storedData));
    });
  });
}

window.addEventListener('DOMContentLoaded', () => {
  const selects = document.querySelectorAll('[data_append] .field select');

  // helper
  const normalizeKey = (str) =>
    str.toLowerCase().replace(/\s+/g, '').trim();

  // localStorage data
  const rawStoredData = JSON.parse(localStorage.getItem('selectedSizes')) || {};

  // normalize storedData keys
  const storedData = {};
  Object.keys(rawStoredData).forEach(key => {
    storedData[normalizeKey(key)] = rawStoredData[key];
  });

  if (selects.length > 0) {
    selects.forEach(select => {
      const selectName = normalizeKey(select.name);

      if (storedData.hasOwnProperty(selectName)) {
        const valueToSelect = storedData[selectName];
        select.value = valueToSelect;
        select.dispatchEvent(new Event('change'));
      }
    });
  }
});

function normalizeProductPersonKey(value) {
  return String(value || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '');
}

function getPersonSizeValueForProduct(noteGroup, personData) {
  if (!noteGroup || !personData) return '';

  const normalizedPersonData = {};
  Object.keys(personData).forEach((key) => {
    normalizedPersonData[normalizeProductPersonKey(key)] = personData[key];
  });

  const productContext = [
    noteGroup.dataset.productHandle,
    noteGroup.dataset.productTitle,
    noteGroup.dataset.productType,
    noteGroup.dataset.productCollections,
  ]
    .join(' ')
    .toLowerCase();

  const keyGroups = [
    { match: ['hemd', 'hemden', 'bluse', 'blusen'], keys: ['hemd'] },
    { match: ['polo'], keys: ['poloshirts', 'poloshirt'] },
    { match: ['t-shirt', 't shirt', 'tshirts'], keys: ['tshirts', 'shirt'] },
    { match: ['hose', 'hosen', 'pants', 'trouser', 'trousers'], keys: ['hosen', 'hose', 'pants'] },
    { match: ['schuh', 'schuhe', 'sicherheitsschuh', 'sicherheitsschuhe', 'shoe', 'shoes'], keys: ['schuhe', 'shoes'] },
    { match: ['softshell'], keys: ['softshelljacken', 'softshelljacke'] },
    { match: ['sweatshirt'], keys: ['sweatshirts', 'sweatshirt'] },
    { match: ['pullover'], keys: ['pullover'] },
    { match: ['weste', 'westen', 'bodywarmer'], keys: ['westen', 'weste'] },
    { match: ['jacke', 'jacken'], keys: ['jacken', 'jacke'] },
  ];

  const matchedGroup = keyGroups.find((group) =>
    group.match.some((term) => productContext.includes(term))
  );

  if (!matchedGroup) return '';

  const matchedKey = matchedGroup.keys.find((key) => normalizedPersonData[key] != null && normalizedPersonData[key] !== '');
  return matchedKey ? String(normalizedPersonData[matchedKey]) : '';
}

function applyPersonSizeToVariantPicker(personSelect) {
  const noteGroup = personSelect.closest('[data-product-note-group]');
  if (!noteGroup) return;

  const selectedOption = personSelect.selectedOptions && personSelect.selectedOptions[0];
  const personJson = selectedOption?.dataset.personJson;
  if (!personJson) return;

  let personData = null;
  try {
    personData = JSON.parse(personJson);
  } catch (error) {
    personData = null;
  }

  const sizeValue = getPersonSizeValueForProduct(noteGroup, personData);
  if (!sizeValue) return;

  const productInfo = noteGroup.closest('product-info');
  const variantSelects = productInfo?.querySelector('variant-selects');
  if (!variantSelects) return;

  const sizeSelect = Array.from(variantSelects.querySelectorAll('select')).find((select) =>
    Array.from(select.options).some((option) => option.value === sizeValue)
  );

  if (sizeSelect && sizeSelect.value !== sizeValue) {
    sizeSelect.value = sizeValue;
    Array.from(sizeSelect.options).forEach((option) => {
      option.toggleAttribute('selected', option.value === sizeValue);
    });
    sizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
    return;
  }

  const sizeRadio = Array.from(variantSelects.querySelectorAll('input[type="radio"]')).find(
    (input) => input.value === sizeValue
  );

  if (sizeRadio && !sizeRadio.checked) {
    sizeRadio.checked = true;
    sizeRadio.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

document.addEventListener('change', (event) => {
  const personSelect = event.target.closest('[data-product-person-select]');
  if (!personSelect) return;

  applyPersonSizeToVariantPicker(personSelect);
});

function togglePersonHistoryView(personId, scope) {
  const root = scope || document;
  const peopleMainView = root.querySelector('[data-people-main-view]');
  const peopleHistoryViews = root.querySelectorAll('[data-person-history-view]');

  if (!peopleMainView || !peopleHistoryViews.length) return;

  if (!personId) {
    peopleMainView.classList.remove('hidden');
    peopleHistoryViews.forEach((view) => view.classList.add('hidden'));
    window.scrollTo({ top: 0, behavior: 'smooth' });
    return;
  }

  peopleMainView.classList.add('hidden');
  peopleHistoryViews.forEach((view) => {
    view.classList.toggle('hidden', view.getAttribute('data-person-history-view') !== personId);
  });
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

document.addEventListener('click', (event) => {
  const openTrigger = event.target.closest('[data-person-history-open]');
  if (openTrigger) {
    const personId = openTrigger.getAttribute('data-person-history-open');
    if (!personId) return;
    const scope = openTrigger.closest('.people-cards');
    togglePersonHistoryView(personId, scope);
    return;
  }

  const closeTrigger = event.target.closest('[data-person-history-close]');
  if (closeTrigger) {
    const scope = closeTrigger.closest('.people-cards');
    togglePersonHistoryView(null, scope);
  }
});
